module.exports = __webpack_public_path__ + "static/pfb-social-2019-8a7155694e4cfc849d3b987cb9a1e6ea.jpg";